import { MaterialSymbol } from "@ui/MaterialSymbol";
import { Stack } from "@ui/Stack";
import { type Accessor, Show } from "solid-js";

export const EmptyClipsList = (props: { isOwner: Accessor<boolean> }) => {
	return (
		<Stack
			direction="column"
			spacing="large"
			class="empty-clips-list-container"
		>
			<Stack direction="column" spacing="small">
				<h2>
					<MaterialSymbol symbol="videocam" />
					No clips in this board
				</h2>
				<Show when={props.isOwner()}>
					<div class="empty-clips-list-text">
						<div>Start adding clips to your board by clicking the</div>
						<div class="empty-clips-list-text-icon">
							<MaterialSymbol symbol="bookmark_add" />
						</div>
						<div>icon while watching any video.</div>
					</div>
				</Show>
			</Stack>
			<div class="empty-clips-list">
				<div />
				<div />
				<div />
				<div />
				<div />
				<div />
			</div>
		</Stack>
	);
};
